export const AWB_REQUIRED_ADDRESS_FIELDS = [
  'address_name',
  'address_phone',
  'address_email',
  'address_line_1',
  'address_line_2',
  'address_city',
  'address_state',
  'address_country',
  'address_pincode',
];

export const WAREHOUSE_VALIDATION_SCHEMA = {
  name: {
    required: 'Name is required',
  },
  party_name: {
    required: 'Party Name is required',
  },
  inventory_available: {
    required: 'Status is required',
  },
  gstin: {
    required: 'GSTIN is required',
  },
  address_name: {
    required: 'Authorised Person is required',
  },
  address_phone: {
    required: 'Phone is required',
    type: 'phone',
  },
  address_email: {
    required: 'Email is required',
    type: 'email',
  },
  address_line_1: {
    required: 'Address Line 1 is required',
  },
  address_line_2: {
    required: 'Address Line 2 is required',
  },
  address_city: {
    required: 'City is required',
  },
  address_state: {
    required: 'State is required',
  },
  address_country: {
    required: 'Country is required',
  },
  address_pincode: {
    required: 'Pincode is required',
  },
  order_sla_hours: {
    required: 'Order SLA Hours is required',
    type: 'number',
  },
};

export const PO_ADDRESS_VALIDATION_SCHEMA = {
  name: {
    required: 'Authorised Person is required',
  },
};
